import { axiosGate2ALL } from '../http-common';

const transaction = (data: object) => {
    return axiosGate2ALL.post('/transactions', JSON.stringify(data));
};

const TransactionServicePayGo = {
    transaction
};

export default TransactionServicePayGo;